import qz from 'qz-tray';

export async function connectQzTray() {
  if (!qz.websocket.isActive()) {
    await qz.websocket.connect({ retries: 2, delay: 1 });
  }
  const printers = await qz.printers.find();
  const version = await qz.api.getVersion();
  return { printers, version };
}

export async function disconnectQzTray() {
  if (qz.websocket.isActive()) await qz.websocket.disconnect();
}

function base64FromAscii(value) {
  return btoa(String.fromCharCode(...new TextEncoder().encode(value)));
}

export async function printQzTest({ printerName, kind }) {
  if (!printerName) throw new Error('请先选择这台电脑上已安装的打印机');
  if (!qz.websocket.isActive()) throw new Error('QZ Tray 未连接，请先点击连接');

  const payload = kind === 'label'
    ? '^XA^CI28^PW640^LL360^FO24,24^A0N,34,34^FDShopFlow QZ TEST^FS^FO24,84^BY2^BCN,100,Y,N,N^FDQZ-TEST-001^FS^XZ'
    : '\x1b@\x1ba\x01SHOPFLOW QZ TEST\n--------------------------------\nPrinter bridge test\nSGD 0.00\n\n\n\x1dV\x00';
  const config = qz.configs.create(printerName, { copies: 1 });
  const data = [{ type: 'raw', format: 'command', flavor: 'base64', data: base64FromAscii(payload) }];
  await qz.print(config, data);
}
